import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";

import { Introducer } from "./introducer.model";

@Injectable()
export class IntroducerSearchService {
    constructor(private http: HttpClient) { }

    search(term: string): Observable<Introducer[]> {
        return this.http.get<Introducer[]>(`api/profile/introducers/?name=${term}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/perspective/introducer-search.service.ts